/**
 * CCW Backorder acknowledgement
 *
 * When the selected variant is backordered (see the 'ccw-backorder-gate' snippet),
 * add to cart opens a prompt with the estimated ship date. Only "I understand,
 * add to cart" goes through, and it stamps the line item so the order shows the
 * customer acknowledged:
 *   Estimated ship date     visible to the customer
 *   _ccw_backorder_ack      "yes" (Shopify Flow tags the order from this)
 *   _ccw_backorder_ack_at   ISO timestamp of the click
 *
 * Runs in the capture phase so it sees the submit before the theme's product-form
 * handler, then re-submits through that same handler once confirmed.
 *
 * Debug: window.CCWBackorder.map() / .lookup(variantId)
 */
(function () {
  'use strict';

  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  var NO_DATE_VALUE = 'When back in stock';

  var pendingForm = null;

  function map() {
    var merged = {};
    var nodes = document.querySelectorAll('[data-ccw-backorder-map]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var data = JSON.parse(nodes[i].textContent);
        for (var id in data) merged[id] = data[id];
      } catch (e) { /* skip a malformed map rather than block add to cart */ }
    }
    return merged;
  }

  function lookup(variantId) {
    if (!variantId) return null;
    return map()[String(variantId)] || null;
  }

  function dialog() {
    return document.querySelector('[data-ccw-backorder-dialog]');
  }

  function addHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    input.value = value;
    input.setAttribute('data-ccw-backorder-prop', '');
    form.appendChild(input);
  }

  function open(form, info) {
    var dlg = dialog();
    if (!dlg || typeof dlg.showModal !== 'function') return false;

    var hasDate = !!info.shipDate;
    dlg.querySelector('[data-ccw-backorder-date]').textContent = info.shipDate || '';
    dlg.querySelector('[data-ccw-backorder-date-row]').hidden = !hasDate;
    dlg.querySelector('[data-ccw-backorder-date-note]').hidden = !hasDate;

    pendingForm = form;
    dlg.showModal();
    dlg.querySelector('[data-ccw-backorder-confirm]').focus();
    return true;
  }

  function close() {
    var dlg = dialog();
    if (dlg && dlg.open) dlg.close();
    pendingForm = null;
  }

  function confirm() {
    var form = pendingForm;
    if (!form) return close();
    var info = lookup((form.querySelector('[name="id"]') || {}).value);
    close();

    addHidden(form, 'Estimated ship date', (info && info.shipDate) || NO_DATE_VALUE);
    addHidden(form, '_ccw_backorder_ack', 'yes');
    addHidden(form, '_ccw_backorder_ack_at', new Date().toISOString());

    // The theme's product-form handler reads the form data synchronously, so the
    // properties can come off right after the submit is dispatched.
    form.__ccwBackorderConfirmed = true;
    try {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    } finally {
      form.__ccwBackorderConfirmed = false;
      var added = form.querySelectorAll('[data-ccw-backorder-prop]');
      for (var i = 0; i < added.length; i++) added[i].remove();
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(FORM_SELECTOR)) return;
    if (form.__ccwBackorderConfirmed) return;

    var info = lookup((form.querySelector('[name="id"]') || {}).value);
    if (!info) return;

    if (open(form, info)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-ccw-backorder-confirm]')) return confirm();
    if (event.target.closest('[data-ccw-backorder-cancel]')) return close();
    // Click on the backdrop (the dialog element itself, outside the inner panel)
    if (event.target.matches && event.target.matches('[data-ccw-backorder-dialog]')) close();
  });

  document.addEventListener('close', function (event) {
    if (event.target.matches && event.target.matches('[data-ccw-backorder-dialog]')) pendingForm = null;
  }, true);

  window.CCWBackorder = { map: map, lookup: lookup };
})();
